import React from 'react';

import H1 from 'apps/Pdf/components/common/H1';
import P from 'apps/Pdf/components/common/P';
import PageBreak from 'apps/Pdf/components/common/PageBreak';

const Disclaimer = () => {
  return (
    <>
      <PageBreak />

      <H1>Důležitá upozornění</H1>
      <P>
        Upozorňujeme zákazníka, že riziko spojené s obchodováním s Investičními nástroji nese on sám
        a výnosy či zachování hodnoty investovaných prostředků není zaručeno. Výsledky dosažené v
        minulosti nejsou v žádném případě zárukou výsledků v budoucnosti.{' '}
      </P>
      <P>
        S ohledem na výše uvedené WOOD Retail Investments a.s. („WOOD RI“) důrazně
        doporučuje svým zákazníkům důkladně se seznámit zejména s dokumentem Informace o
        investičních službách, investičních nástrojích a rizicích spojených s investováním do těchto
        investičních nástrojů. Dále WOOD RI žádá zákazníka, aby WOOD RI bez zbytečného odkladu
        informoval o změně skutečností uvedených v investičním dotazníku, zejména pak o změnách,
        které mohou mít vliv na určení investiční strategie, jako je podstatná změna výše příjmů či
        výdajů (např. v důsledku narození potomka, rozvodu, ztráty zaměstnání atd.).
        <br />
        Poskytnutím pravdivých a aktuálních informací zákazník umožní společnosti WOOD RI lépe vyhodnotit
        jeho osobní situaci a navrhnout vhodnou investiční strategii.{' '}
      </P>
      <P>
        Custody služby klientům zajišťuje WOOD RI - cenné papíry jsou drženy na segregovaných účtech u depozitářů prostřednictvím custodianů:
        Intesa Sanpaolo S.P.A. a WOOD & Company Financial Services a.s.. Hotovostní zůstatky portfolií jsou uloženy na klientských sběrných účtech WOOD RI vedených u Fio banka, a.s.,
        Citibank Europe plc, organizační složka, dále v Komerční banka, a. s. a Banka CREDITAS a.s.. Mimo to mohou být hotovostní prostředky na custody účtech vlastněných
        WOOD & Company Financial Services a.s. u Citibank Europe plc, organizační složka, Intesa Sanpaolo S.P.A.. a ING BELGIUM NV/SA.
      </P>
      <P>
        Služba poskytovaná klientovi prostřednictvím aplikace Edward na základě uzavřené Smlouvy opravňuje WOOD RI nakupovat pro klienta  v rámci dohodnuté investiční strategie
        vybrané investiční nástroje. Všechny realizované investice jsou společností WOOD RI. realizovány s odbornou péčí a za pro klienta nejlepších podmínek dosažitelných na trhu.
      </P>
    </>
  );
};

export default Disclaimer;
